export default function printResult() {
    const message = prompt("Enter your message:");
    alert(message);
}
printResult()